import { PatientInformation } from "~/patients/utils/types";
import { api } from "./axios";

export const getAuthenticatedPatient = async () => {
  const response = await api.get<PatientInformation>("/v1/patients/current");
  return response.data;
};
